<template>
<div class="page_tixian">
	<!-- 银行卡 -->
	<div class="card" @click="clickSelectBank">
		<div class="card_l" v-if="selectBank">
			<img :src="bankLogo" alt="" class="card_icon">
			<div class="card_info">
				<div class="card_type">{{ selectBank.opening_bank }}</div>
				<div class="card_num">{{ selectBank.card_number }}</div>
			</div>
		</div>
        <div class="card_l" v-else>
			<div class="user">请选择银行卡</div>
		</div>
	</div>
    <!-- 提现类型 -->
    <van-radio-group v-model="selectType" >
        <van-cell-group class="cell_group">
            <van-cell :border="false" clickable v-for="point in txTypes" :key="point.type" @click="selectType = point.type" class="order_pro">
                <template #title>
                    <span class="custom-title pro_l">{{point.name+'￥'+point.money}}</span>
                </template>
                <template #right-icon>
                    <van-radio :name="point.type" class="pro_r">
                        <template #icon="props">
                            <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
                        </template>
                    </van-radio>
                </template>
            </van-cell>
        </van-cell-group>
    </van-radio-group>
	<!-- 提现 -->
	<div class="tixian">
		<div class="tixian_top">
			<div class="name">提现金额</div>
			<div class="action" @click="clickAllPrice">全部提现</div>
		</div>
		<!-- 余额 -->
		<div class="balance">
			<div class="balance_t">
				<span class="tag_cash">¥</span>
				<van-field v-model="cash" type="number" placeholder="请输入提现金额" class="cash_field"/>
			</div>
			<div class="balance_b">
				<div class="tips_balance">可用余额<span class="price"><span class="tag_price">¥</span>{{ allPrice ? allPrice : 0 }}</span></div>
				<div class="tips_fee" v-if="is_park == 1">*园区商户提现手续费1元</div>
				<div class="tips_fee" v-if="is_park != 1">*提现每笔2元，1000元以上免除手续费</div>
			</div>
		</div>
	</div>
	<!-- 确认提现 -->
	<!-- <div class="big_btn" @click="withdraw">确认提现</div> -->
	<van-button block :loading="submitLoading" class="big_btn" @click="withdraw">确认提现</van-button>
	<!-- 提现规则 -->
	<div class="guize" @click="goPage">提现规则</div>
	
    <!-- 列表 -->
    <!-- <div class="name">输入提现金额</div>
    <div class="name">选择提现类型</div>
    <div class="name">选择银行卡</div>
    <div class="name" @click="withdraw">提现</div> -->
</div>
</template>

<script>
import Vue from 'vue';
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN,
    SELECTBANK,
    REMOVEBANK
} from "../../../../.././vuex/mutation_types";
import Bridge from '../../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent
export default {
    // name: "map-index",
    data() {
        return {
            activeIcon: process.env.BASE_URL + './statics/images/active.png',
            inactiveIcon: process.env.BASE_URL + './statics/images/inactive.png',
            allPrice: this.$route.query.price, // 可用余额
            type: this.$route.query.type,
            publicPath: process.env.BASE_URL,
            token: null,
            bankList: [],
            selectBank: null,
            bankLogo: process.env.BASE_URL + './statics/images/my/bank/default.png',
			cash: null , // 提现金额
            tradesman_id: this.$route.query.tradesman_id,
            info: {},
            selectType: this.$route.query.type,
			txTypes:[],
			submitLoading: false,
			is_park: null // 是否为园区商户 0匠人 1园区 2专家
        };
    },
    created: function () {
        //根据userAgent判断是否在iOSAndroid客户端中
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            this.isClient = true
            var params = {
                data: {
                    naviTitle: "提现"
                }
            };
            this.$bridge.callhandler("sdjy://navigation/style", params, data => {});
            //加载用户信息
            var memberParams = {
                'data': {}
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                console.log(data)
                console.log('111')
                if (data.code == 200) {
                    this.token = data.result.token
                    this.getData()
                    this.getUserData();
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                var params2 = {
                    'data': {
                        'key': 'selectBank'
                    }
                }
                this.$bridge.callhandler('sdjy://public/getInfo', params2, (data2) => {
                    if (data2.code == 200) {
                        var selectBank = JSON.parse(data2.result.data)
                        if (selectBank) {
                            this.selectBank = selectBank
                            this.setBankLogo()
                        }
                        this.$bridge.callhandler('sdjy://public/removeInfo', params2, (data1) => {

                        })
                    }
                })
                responseCallback(data)
            })
        } else {
            this.isClient = false
            // 获取列表
            this.token = this.$store.getters.token
            this.getData();
            this.getUserData();
        }
    },
    mounted() {
        var bank = this.$store.getters.select_bank
        console.log('select-bank:',bank)
        if (bank && bank != undefined && bank != '') {
            var selectBank = JSON.parse(bank)
            console.log('selectBank:',selectBank)
            if (selectBank) {
                this.selectBank = selectBank
                this.setBankLogo()
                this.$store.commit('REMOVEBANK');
            }
        } else {
            
        }
    },
    methods: {
        getUserData() {
            var param = {
				token: this.token,
				tradesman_id: this.tradesman_id
            }
            this.$api.user.index(param).then(res => {
                if (res.code == 200) {
					this.info = res.result.info.useraccount,
					this.is_park = res.result.tid.is_park // 0匠人 1园区 2专家
                    var list = []
                    //1商城 2云支付 3城市合伙人4代理商户5用户提现6供应商 
                    if (this.info.trad_money && this.info.trad_money > 0) {
                        list.push({'name':'匠人余额','money':this.info.trad_money,'type':1})
                    }
                    if (this.info.seller_money && this.info.seller_money > 0) {
                        list.push({'name':'供应商余额','money':this.info.seller_money,'type':6})
                    }
                    if (this.info.agent_money && this.info.agent_money > 0) {
                        list.push({'name':'分销商余额','money':this.info.agent_money,'type':4})
                    }
                    if (this.info.partner_money && this.info.partner_money > 0) {
                        list.push({'name':'城市合伙人余额','money':this.info.partner_money,'type':3})
                    }
                    this.txTypes = list
                } else {
                    // this.$toast(res.message)
                }
            })
        },
        clickSelectBank() {
            console.log('clickSelectBank')
            // if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            //     var params = {
            //         'data': {
            //             'url': this.$publicData.clientUrl + '/bank/index?canSelect=1'
            //         }
            //     }
            //     this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

            //     })
            // } else {
                this.$router.push({
                    path: '/bank/index',
                    query: {
                        canSelect: 1
                    }
                })
            // }
        },
        clickAllPrice() {
            for (let i = 0; i < this.txTypes.length; i++) {
                const type = this.txTypes[i];
                if (type.type == this.selectType) {
                    this.cash = type.money
                    break
                }
                
            } 
        },
        //提现
        withdraw() {
			this.submitLoading = true
            if (this.cash == null || this.cash == undefined || this.cash == '') {
				this.$toast('请输入提现金额')
				this.submitLoading = false
                return
            }
            if (this.selectBank == null || this.selectBank == undefined || this.selectBank == {} || this.selectBank.id == null || this.selectBank.id == undefined || this.selectBank.id == '') {
				this.$toast('请选择提现银行卡')
				this.submitLoading = false
                return
            }
            var params = {
                token: this.token,
                money: this.cash,
                type: this.selectType,
                bank_card_id: this.selectBank.id
            }
            this.$api.my.withdraw(params).then(res => {
                if (res.code == 200) {
					this.$toast('提现成功')
                    if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                        var params = {
                            'data': {}
                        }
                        this.$bridge.callhandler('sdjy://public/back', params, (data) => {

                        })
                    } else {
                        this.$router.back()
                    }
                } else {
					this.$toast(res.message)
					this.submitLoading = false
                }
            })
        },
        // 获取列表
        getData() {
            var params = {
				token: this.token,
            }
            this.$api.my.bankList(params).then(res => {
                if (res.code == 200) {
                    this.bankList = res.result
                    if (this.bankList && this.bankList.length > 0) {
                        console.log(this.selectBank)
                        if (this.selectBank == null || this.selectBank == undefined || this.selectBank == {}) {
                            this.selectBank = this.bankList[0];
                            this.setBankLogo()
                        }
                    }
                }

            })
		},
        setBankLogo() {
            if (this.selectBank && this.selectBank!=undefined) {
                console.log(this.selectBank.opening_bank)
                if (this.selectBank.opening_bank.indexOf('工商') > -1) {
                    this.bankLogo = process.env.BASE_URL + './statics/images/my/bank/gonghang.png'
                } else if (this.selectBank.opening_bank.indexOf('农业') > -1) {
                    this.bankLogo = process.env.BASE_URL + './statics/images/my/bank/nonghang.png'
                } else if (this.selectBank.opening_bank.indexOf('建设') > -1) {
                    this.bankLogo = process.env.BASE_URL + './statics/images/my/bank/jianhang.png'
                } else if (this.selectBank.opening_bank.indexOf('交通')> -1) {
                    this.bankLogo = process.env.BASE_URL + './statics/images/my/bank/jiaohang.png'
                } else if (this.selectBank.opening_bank.indexOf('招商')> -1) {
                    this.bankLogo = process.env.BASE_URL + './statics/images/my/bank/zhaohang.png'
                } else if (this.selectBank.opening_bank.indexOf('中国银行')> -1) {
                    this.bankLogo = process.env.BASE_URL + './statics/images/my/bank/zhaohang.png'
                } else {
                    this.bankLogo = process.env.BASE_URL + './statics/images/my/bank/default.png'
                }
            } else {
                this.bankLogo = process.env.BASE_URL + './statics/images/my/bank/default.png'
            }
        },
		// 页面跳转
		goPage(){
			this.$router.push({
				path: '/single/page',
				query: {
					id: 7 // 7 提现规则
				}
			})
		},
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.img-icon {
    width: 0.53rem;
    height: 0.53rem;
}
/deep/.van-button{
	line-height: normal;
}
</style>
